import { SHStack, SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { isNil } from "lodash";
import { memo } from "react";
import { BooleanCell } from "../boolean-cell";
interface SimpleNumberCellProps {
  analysisData?: AnalysisDataDTO | MAAnalysisDataDTO;
}

export const SimpleNumberCell = memo(
  ({ analysisData }: SimpleNumberCellProps) => {
    const isPositiveScore =
      analysisData && analysisData && "isPositiveScore" in analysisData
        ? analysisData?.isPositiveScore
        : undefined;

    return (
      <SHStack direction={"row"} alignItems={"center"} gap={0.5}>
        <SHTypography
          variant="body3"
          zIndex="1"
          colorVariant="third"
          textAlign="justify"
        >
          {analysisData?.value}
        </SHTypography>
        {!isNil(isPositiveScore) && <BooleanCell value={isPositiveScore} />}
      </SHStack>
    );
  },
);
